import React, { useState, useEffect } from "react";
import Styles from "../../styles.module.scss"
import SideMenu from "../../sideMenu";
import DashboardHeader from "../../dashboardHeader"
import Tab from '../../../../components/tab';
import Resume from './resume'; 
import PersonalDetails from './personalDetails'; 
import Skills from './skills';
import Availability from './availability';
import WorkHistory from './workHistory';
import Projects from './projects';
import Headline4 from "../../../../components/headings/Headline4";
// import Accademic from './accademic';
import Awards from './Awards';
import Preferences from './preferences';
import * as CONSTANTS from '../../../../utils/CONSTANTS';
import { checkAvailability, checkContractType, checkWorkType, makeSideBarActive, checkJobCriteria  ,  checkTypeofCompany , checkWorkLocation ,  checkCareerType ,  submitMixPanel } from '../../../../utils/EllowUtils';
import { getDetails, submitProfile, updateProfiles } from './services';
import NotificationAlert from "../../../../components/notification";
import { PanelBar, PanelBarItem, TabStrip } from "@progress/kendo-react-layout";
import {
  TabStripSelectEventArguments,
} from "@progress/kendo-react-layout";
import {useLocation} from 'react-router-dom'
import Accademic from './education'
import Languages from "./language";
import Publication from "./publications";
import Preview from "../../../../common/resumePreview/preview";
import mixpanelData, { userProfile, viewedpageMixpanel } from "../../../../utils/mixpanel";
import { Icon } from "@iconify/react";



function MyProfile(props : any ) {
  
    const [selected, setSelected] = React.useState<number>(0);
    const [flag, setFlag] = React.useState<boolean>(false);
    
    const location= useLocation()
    const select: any = location.state ? location.state : {}
    const selector : number  = select.selector ? select.selector : 0
    
    
    const availId = localStorage.getItem('availableId')
    const menu = makeSideBarActive(CONSTANTS.sideMenuFreelancer, 2)
    const loginId = localStorage.getItem('loginId')
    const [candidateId, setCandidateId] = useState<string>('')
    const [notification, setNotification] = useState<boolean>(false)
    const [message, setMessage] = useState<string>('')
    const [englishProficiency , setEnglishProficiency] = useState<any>()
    const [disableProfileButton , setDisableProfileButton] = useState<boolean>(false)
    // const [disableSkillButton , setDisableSkillButton] = useState<boolean>(false)
    // const [disableAvailabilityButton , setDisableAvailabilityButton] = useState<boolean>(false)
    // const [disablePreferenceButton , setDisablePreferenceButton] = useState<boolean>(false)
    const [disable , setDisable] = useState<boolean>(false)
    const [resume, setResume] = useState<string | null>(null)
     const [profileValues, setProfileValues] = useState<{ firstName?: string; lastName?: string; email?: string; phoneNumber?: string; nationality?: string; country?: string; city?: string; github?: string ; linkedIn?: string ; stackoverflow: string ; summary: string }>({ firstName: '', lastName: 'kl', email: '', phoneNumber: '', github: '', stackoverflow: '', linkedIn: '', country: '', nationality: '', city:'', summary: ''})
    const [preferenceValues, setpreferenceValues] = useState<{ 
      timeZone?: string[] ; 
      salary: {billingType: string; currencyType:string; expectedPay:string};
      locationPreference: {remoteType:number | undefined; location: {id:string; name:string}[]} 
      companyType: number;
      }>({
        timeZone: [],
        salary: {billingType:'', currencyType:'', expectedPay:''},
        locationPreference: {remoteType: undefined, location: []},
        companyType: 0
      })
    const [allData, setAllData] = useState<any>()
    
    const [skillValues, setSkillValues] = useState<{
      workExperience: number,
      jobRoles: { name: string, id: number }[],
      techStack: { experience: string; expertise: number; skill: { skillId: number; skillName: string; }; stackId: number; }[],
      cloudProficiency: {id:number; name:string}[],  otherSkills: { skillId: number, skillName: string }[],
      positionName: string
    }>({
      workExperience: 0,
      jobRoles: [],
      techStack: [{ experience: "", expertise: 0, skill: { skillId: 0, skillName: '' }, stackId: 0 }],
      cloudProficiency:[] , otherSkills:[] , positionName: ""
    })
    // const [availabilityValues, setAvailabilityValues] = useState<{ availability?: {availabilityId?: number | undefined, date?: string | undefined}; contractType?: number | undefined; workType?: number | undefined; }>()
 
  const [experienceValues, setExperienceValues] = useState<{
     workHistory: { designation: string, companyName: string, description: string, startDate:number, endDate:number, stillWorking:boolean}[],
     project : {name:string, companyName:string, doneFor:string, contribution:string, skills:{skillName:string, skillId:number}[], link:string}[]
    }>({
      workHistory: [],
      project : []
    })

  const [academicValues, setAccademicValues] = useState<{
    education: {degree: string, institution: string, startDate: number, endDate:number, action: string}[],
    language: {name: string, proficiency: string, action: string, languageId?: string}[]
  }>({
    education: [],
    language: []
  })
  const [awardsValues, setAwardsValues] = useState<{
    awards: {name: string, certifiedYear: number, action: string, status:boolean}[],
    publication: { title: string, year: number, link: string, status: boolean}[]
  }>({
    awards: [],
    publication: []
  })

  // const [editorState, setEditorState] = React.useState(EditorState.createEmpty());
 const[profileSubmitted, setProfileSubmitted] = useState<boolean>(false)


  const [availabilityValues, setAvailabilityValues] = useState({
    availability: {
      availabilityId: 1,
      date: ""
    },
    contractType: 1,
    workType: 1,
    jobSearchCriteria:1
    })
    
    

    
  useEffect(() => {
    
    getUserDetails(loginId); 
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availId , selector])

  useEffect(() => {
    
    viewedpageMixpanel(); 
    
  },[])

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);    
    setFlag(true)
  };
  


   
   const getUserDetails = (id: string | null)  => {
     getDetails(id).then((response) => {
       if (response && response.status === 1) {  
         if (response.data[0].candidate_status > 2 && response.data[0].candidate_status < 6) {
           setProfileSubmitted(true)
         }
        setEnglishProficiency(response.data[0].profile_metadata.englishProficiency)
        setCandidateId(response.data[0].candidate_id)
        setResume(response.data[0].resume_file_name) 
        setAllData(response.data[0].profile_metadata)
        localStorage.setItem("profile_metadata", JSON.stringify(response.data[0].profile_metadata))
                              
          let porofDetails = {
            country: response.data[0].profile_metadata.country,
            email: response.data[0].profile_metadata.email,
            firstName: response.data[0].profile_metadata.firstName,
            github: response.data[0].profile_metadata.github,
            lastName: response.data[0].profile_metadata.lastName,
            linkedIn: response.data[0].profile_metadata.linkedIn,
            city: response.data[0].profile_metadata.city,
            nationality: response.data[0].profile_metadata.nationality,
            phoneNumber: response.data[0].profile_metadata.phoneNumber ? response.data[0].profile_metadata.phoneNumber.toString() : null,
            stackoverflow: response.data[0].profile_metadata.stackoverflow,
            summary: response.data[0].profile_metadata.summary
          }
          setProfileValues(porofDetails)
          console.log('porofDetails', porofDetails);
          

          skillValues.workExperience = response.data[0].profile_metadata.workExperience;
          skillValues.jobRoles = response.data[0].profile_metadata.jobRoles;
          skillValues.techStack = response.data[0].profile_metadata.techStack;
          skillValues.cloudProficiency=response.data[0].profile_metadata.cloudProficiency;
          skillValues.otherSkills= response.data[0].profile_metadata.otherSkills;
          skillValues.positionName = response.data[0].profile_metadata.positionName 
          setSkillValues({ ...skillValues })

          availabilityValues.availability = response.data[0].profile_metadata.availability
          availabilityValues.contractType = parseInt(response.data[0].profile_metadata.contractType)
          availabilityValues.workType = parseInt(response.data[0].profile_metadata.workType)
          availabilityValues.jobSearchCriteria = response.data[0].profile_metadata.jobSearchCriteria && parseInt(response.data[0].profile_metadata.jobSearchCriteria)   
          setAvailabilityValues({...availabilityValues})
          setSelected(flag ? selected : selector ? selector : selected)
          // selector && flag

          experienceValues.workHistory = response.data[0].profile_metadata.workHistory
          experienceValues.project = response.data[0].profile_metadata.project
          setExperienceValues({...experienceValues})
         
          academicValues.education = response.data[0].profile_metadata.education
          academicValues.language = response.data[0].profile_metadata.language
          setAccademicValues({...academicValues})

          awardsValues.awards=response.data[0].profile_metadata.certification
          awardsValues.publication=response.data[0].profile_metadata.publication
          setAwardsValues({...awardsValues})

          let preference = {
            timeZone:typeof(response.data[0].profile_metadata.preference.timeZone) === 'object' ? response.data[0].profile_metadata.preference.timeZone : [] ,
            locationPreference:response.data[0].profile_metadata.preference.locationPreference,
            salary:response.data[0].profile_metadata.preference.salary,
            companyType:response.data[0].profile_metadata.preference.companyType && response.data[0].profile_metadata.preference.companyType
          }      
          setpreferenceValues(preference)
       }

     })
   }

   const updateUserDetails = (data: any) => {
         
    data.candidateId = candidateId;
    setMessage('details stored successfully')
    setNotification(true)
        setTimeout(() => {
          setNotification(false)
        }, 4000);
   }

   const updateProfileValues = (data: any) => {
    if(data !== undefined && data.firstName){
      setDisableProfileButton(true)
    } 
    // if(data !== undefined && data.positionName){
    //   setDisableSkillButton(true)
    // } 
    // if(data !== undefined && data.availability){
    //   setDisableAvailabilityButton(true)
    // } 
    // if(data !== undefined && data.preference){
    //   setDisablePreferenceButton(true)
    // }  
    let values = {
      loginId: loginId,
      userLoginId: loginId,
      profileMetadata: data
     }
     updateProfiles(values).then((response) => {
      if(response && response.status === 1){
        window.scrollTo(0, 0);
        localStorage.setItem("profile_metadata",JSON.stringify(response.data[0].profile_metadata))  
        localStorage.setItem('availablityId',response.data[0].profile_metadata.availability.availabilityId)

        if(response.data[0].profile_metadata.availability.availabilityId === 2){
          localStorage.setItem('date',response.data[0].profile_metadata.availability.date)
        }
        if(response.data[0].profile_metadata.availability.availabilityId === 3){
          localStorage.setItem('weeks',response.data[0].profile_metadata.availability.weeks)
        }
        const skillsName = response.data[0].profile_metadata && response.data[0].profile_metadata.techStack && response.data[0].profile_metadata.techStack.map((item: any) => { return (item.skill.skillName) })
        const jobRolesNames: string[] = response.data[0] && response.data[0].profile_metadata && response.data[0].profile_metadata.jobRoles && response.data[0].profile_metadata.jobRoles.map((item: {id: number, name: string}) => { return(item.name)}) 
        
        userProfile({
          '$name': response.data[0].profile_metadata.firstName + " " + response.data[0].profile_metadata.lastName ,
          'loginId': response.data[0].login_id,
          '$email': response.data[0].profile_metadata.email,
          '$phone': response.data[0].profile_metadata.phoneNumber && response.data[0].profile_metadata.phoneNumber.toString() ? response.data[0].profile_metadata.phoneNumber.toString() : '',
          'Skills': skillsName,
          'Job role': jobRolesNames,
          'Work experience': response.data[0].profile_metadata.workExperience,
          'Work type': response.data[0].profile_metadata.workType && checkWorkType(parseInt(response.data[0].profile_metadata.workType)),
          'Contract Type': response.data[0].profile_metadata.contractType && checkContractType(parseInt(response.data[0].profile_metadata.contractType.contractType)),
          'Availability': response.data[0].profile_metadata.availability && checkAvailability(response.data[0].profile_metadata.availability),
          'Expected salary': response.data[0].profile_metadata.preference ? response.data[0].profile_metadata.preference.salary && response.data[0].profile_metadata.preference.salary.expectedPay + ' ' + response.data[0].profile_metadata.preference.salary.currencyType + ' ' + response.data[0].profile_metadata.preference.salary.billingType : 'Not Mentioned',
          'allocatedTo': response.data[0].allocatedToUserName && response.data[0].allocatedToUserName, 
          'sourcedBy': response.data[0].sourced_by && response.data[0].sourced_by,
        }, response.data[0].login_id) 
        getUserDetails(loginId)
        setMessage('Details saved successfully')
        setDisableProfileButton(false)
        // setDisableSkillButton(false)
        // setDisableAvailabilityButton(false)
        // setDisablePreferenceButton(false)
        setNotification(true)
        setTimeout(() => {
          setNotification(false)
        }, 4000);

      }
     })
   }
   
   const onClose = () => {
    setNotification(false)
   }

   const redirectToAvailability = () => {
     setSelected(2)
   }

   const displayNotification = (message: string) => {
     setMessage(message)
     setNotification(true)
     setTimeout(() => {
        setNotification(false)
      }, 4000);
   }
   
  const submitCheck = (value:boolean,data:any) => {
    setDisable(true)
    if (!value) {
      submitProfile(data).then((response) => {
        if (response && response.status === 1) {
          const coreSkills: string[] =  response.data[0].profile_metadata && response.data[0].profile_metadata.techStack.map((item: any, experience: any, expertise: any) => { return (item.skill.skillName) })
          const jobRolesNames: string[] = response.data[0].profile_metadata && response.data[0].profile_metadata.jobRoles && response.data[0].profile_metadata.jobRoles.map((item: { id: number, name: string }) => { return (item.name) })
          const otherSkills: string[] = response.data[0].profile_metadata && response.data[0].profile_metadata.otherSkills && response.data[0].profile_metadata.otherSkills.length > 0 && response.data[0].profile_metadata.otherSkills.map((item: any) => { return (item.skillName)})
          let socailaProfile = []
            response.data[0].profile_metadata.linkedIn && socailaProfile.push({"linkedIn": response.data[0].profile_metadata.linkedIn}) 
            response.data[0].profile_metadata.github && socailaProfile.push({"github": response.data[0].profile_metadata.github}) 
            response.data[0].profile_metadata.stackoverflow && socailaProfile.push({"stackoverflow": response.data[0].profile_metadata.stackoverflow}) 
          let certifications = response.data[0].profile_metadata && response.data[0].profile_metadata.ellowScreeningCertifications &&
            response.data[0].profile_metadata.ellowScreeningCertifications.map((item: any) => {
              return( item.skills.name)
            })
          let locations = response.data[0].profile_metadata.preference && response.data[0].profile_metadata.preference.locationPreference && response.data[0].profile_metadata.preference.locationPreference.location.map((item: any) => {
              return item.name
            })  
          mixpanelData('New MWP - Full profile submit', {
            'distinct_id':  response.data[0].profile_metadata.email, 
            'Candidate name': response.data[0].profile_metadata.firstName + ' ' + response.data[0].profile_metadata.lastName,
            'Candidate email':  response.data[0].profile_metadata.email,
            'Candidate loginid':  loginId,
            'Date': new Date().toDateString(),
            'Availibility': response.data[0].profile_metadata.availability &&  checkAvailability(response.data[0].profile_metadata.availability),
            'Contract type': response.data[0].profile_metadata.availability && checkContractType(parseInt(response.data[0].profile_metadata.contractType)),
            'Phone number': response.data[0].profile_metadata.phoneNumber,
            'Skills': coreSkills,
            'Job role': jobRolesNames,
            'Social profile': socailaProfile,
            'Certifications': certifications,
            'Prefered company type': response.data[0].profile_metadata && response.data[0].profile_metadata.preference && response.data[0].profile_metadata.preference.companyType && checkTypeofCompany(response.data[0].profile_metadata.preference.companyType),
            'Designation': response.data[0].profile_metadata.positionName && response.data[0].profile_metadata.positionName,
            'Prefered location': response.data[0].profile_metadata && response.data[0].profile_metadata.preference && response.data[0].profile_metadata.preference.locationPreference && checkWorkLocation(response.data[0].profile_metadata.preference.locationPreference.remoteType, response.data[0].profile_metadata.preference.locationPreference.location),
            'Location array': locations,
            'Prefered salary': response.data[0].profile_metadata.preference ? response.data[0].profile_metadata.preference.salary && response.data[0].profile_metadata.preference.salary.expectedPay + ' ' + response.data[0].profile_metadata.preference.salary.currencyType + '/' + response.data[0].profile_metadata.preference.salary.billingType : 'Not Mentioned',
            'Work type': checkCareerType(parseInt(response.data[0].profile_metadata.workType)),
            'Level': response.data[0].profile_metadata && response.data[0].profile_metadata.assessmentLevel,
            'Source type': response && response.data && response.data[0].sourced_by,
            'Source name': response && response.data && response.data[0].behalfOfName,
            "Resume name": response.data[0].profile_metadata && response.data[0].profile_metadata.resumeFileName,
            "Employee id": response && response.data[0] && response.data[0].employee_id,
            "Country": response.data[0].profile_metadata && response.data[0].profile_metadata.country,
            "Nationality": response.data[0].profile_metadata && response.data[0].profile_metadata.nationality,
            'Experience': response.data[0].profile_metadata && response.data[0].profile_metadata.workExperience + 'Years',
            'Other skills': otherSkills,
            'Job search criteria': response.data[0].profile_metadata && checkJobCriteria(parseInt(response.data[0].profile_metadata.jobSearchCriteria)),
            'Allocated to': response.data[0] && response.data[0].allocatedToUserName,
            'Company type': response.data[0].profile_metadata && response.data[0].profile_metadata.preference && checkTypeofCompany(response.data[0].profile_metadata.preference.companyType),
            'Time zone': response.data[0].profile_metadata && response.data[0].profile_metadata.preference && response.data[0].profile_metadata && response.data[0].profile_metadata.preference.timeZone
          })     
          userProfile({
            '$name': response.data[0].profile_metadata.firstName + " " + response.data[0].profile_metadata.lastName ,
            'loginId': localStorage.getItem('loginId'),
            '$email': response.data[0].profile_metadata.email,
            '$phone': response.data[0].profile_metadata.phoneNumber && response.data[0].profile_metadata.phoneNumber.toString() ? response.data[0].profile_metadata.phoneNumber.toString() : '',
            'Skills': coreSkills,
            'Job role': jobRolesNames,
            'Other skills': otherSkills,
            'Work experience': response.data[0].profile_metadata.workExperience,
            'Work type': response.data[0].profile_metadata.workType && checkWorkType(parseInt(response.data[0].profile_metadata.workType)),
            'Contract type': response.data[0].profile_metadata.contractType && checkContractType(parseInt(response.data[0].profile_metadata.contractType.contractType)),
            'Availability': response.data[0].profile_metadata.availability && checkAvailability(response.data[0].profile_metadata.availability),
            'Expected salary': response.data[0].profile_metadata.preference ? response.data[0].profile_metadata.preference.salary && response.data[0].profile_metadata.preference.salary.expectedPay + ' ' + response.data[0].profile_metadata.preference.salary.currencyType + ' ' + response.data[0].profile_metadata.preference.salary.billingType : 'Not Mentioned',
            'Allocated to': response.data[0].allocatedToUserName && response.data[0].allocatedToUserName, 
            'Location preference': response.data[0].profile_metadata.preference && response.data[0].profile_metadata.preference.locationPreference && response.data[0].profile_metadata.preference.locationPreference.location.map((item: any) => {return(item.name)}),
            'Company type': response.data[0].profile_metadata && response.data[0].profile_metadata.preference && checkTypeofCompany(response.data[0].profile_metadata.preference.companyType),
            'Sourced by': 'FREELANCER',
            'Country': response.data[0].profile_metadata.country,
            'Nationality': response.data[0].profile_metadata.nationality,
            'ellow status': 'F3 - Verified',
          }, localStorage.getItem('loginId') )
          getUserDetails(loginId); 
          setDisable(false)
          setMessage('ProfileSubmitted Successfully')
          setNotification(true)
          setTimeout(() => {
             setNotification(false)
           }, 4000);
           submitMixPanel(response)
        }else{
          setDisable(false)
        }
     })
   }
  }

  const onClick = () => {
    // window.scrollTo(500, 0);
    window.scrollTo({
     top: 0,
     left: 0,
     behavior: "smooth"
   });
   }
   
    return (
      <section className={Styles.dashboardWrapper}>
        <SideMenu menu={menu} />

        <div className={Styles.dashboardContent}>
          
          <DashboardHeader redirectToAvailability={redirectToAvailability}/>
          {notification && <NotificationAlert onClose={onClose } closable={true} >
          {message}
          </NotificationAlert> }
          
              <div className={Styles.profile}>
                <TabStrip selected={selected} onSelect={handleSelect}>
                  <Tab title="Resume">
                    <Resume loginId={loginId} getUserDetails={getUserDetails} resume={resume}/>
                  </Tab>
                  <Tab title="Detailed Profile">
                  <div className="panelbarwrapperMyprofile">
                    <Headline4>Detailed Profile</Headline4> 
                    <PanelBar className="personal-details-panel">
                      <PanelBarItem expanded={true} title="Personal Details">
                          <PersonalDetails ClickHandler={updateProfileValues} defaultValues={profileValues} disable={disableProfileButton}/>
                      </PanelBarItem>
                      <PanelBarItem expanded={true} title='Skills'>
                          <Skills OnSubmit={updateProfileValues} defaultValues={skillValues} />
                      </PanelBarItem>
                      <PanelBarItem expanded={true} title="Work History">
                          <WorkHistory  ExperienceHandler={updateUserDetails} loginId={loginId} defaultValues={experienceValues} ProjectHandler={updateUserDetails} getUserDetails={getUserDetails} displayNotification={displayNotification}/>
                      </PanelBarItem>
                      <PanelBarItem expanded={true} title="Projects">
                          <Projects  ExperienceHandler={updateUserDetails} loginId={loginId} defaultValues={experienceValues} ProjectHandler={updateUserDetails} getUserDetails={getUserDetails} displayNotification={displayNotification}/>
                      </PanelBarItem>
                      <PanelBarItem expanded={true} title="Education">
                          <Accademic LanguageHandler={updateUserDetails} loginId={loginId} defaultValues={academicValues} getUserDetails={getUserDetails} displayNotification={displayNotification}/>
                      </PanelBarItem>
                      <PanelBarItem expanded={true} title="Languages">
                          <Languages LanguageHandler={updateUserDetails} loginId={loginId} defaultValues={academicValues} getUserDetails={getUserDetails} displayNotification={displayNotification} englishProficiency={englishProficiency}/>
                      </PanelBarItem>
                          {/* <Accademic LanguageHandler={updateUserDetails} loginId={loginId} defaultValues={academicValues} getUserDetails={getUserDetails}/></PanelBarItem> */}
                      <PanelBarItem expanded={true} title="Awards & Certifications">
                          <Awards  AwardHandler={updateUserDetails}  loginId={loginId} defaultValues={awardsValues}  getUserDetails={getUserDetails} displayNotification={displayNotification}/>
                      </PanelBarItem>
                      <PanelBarItem expanded={true} title="Publications">
                          <Publication   loginId={loginId} defaultValues={awardsValues} PublicationHandler={updateUserDetails} getUserDetails={getUserDetails} displayNotification={displayNotification}/>
                    </PanelBarItem>

                    <div className={Styles.shareandprint}>
                         <button onClick={onClick} title="Move to top">
                          <Icon icon="octicon:move-to-top-16" />
                         </button>
                    </div>
                    
                    </PanelBar>
                  </div>
                  </Tab>
                  <Tab title="Availability">
                    <Availability loginId={loginId}   OnSubmit={updateProfileValues} defaultValues={availabilityValues} />
                  </Tab>
                  <Tab title="Preferences">
                    <Preferences loginId={loginId}  ClickHandler={updateProfileValues}   defaultValues={preferenceValues} />
                  </Tab>
                  {/* <Tab title="Timesheet">
                    <Timesheet loginId={loginId}   OnSubmit={updateProfileValues} defaultValues={availabilityValues} />
                  </Tab> */}
              <Tab title="Preview">
                <Preview showSubmit={true } candaidateData={allData} profileSubmitted={profileSubmitted} submitCheck={submitCheck} editClick={() => setSelected(1) } disable={disable}/>
                 </Tab>
                </TabStrip>
              </div>
        </div>
      </section>
    );
}
export default MyProfile
